// extracted by mini-css-extract-plugin
export default {"input":"jpa-z","button":"kpa-z","selected":"lpa-z","unavailable":"mpa-z","image":"npa-z"};